import IMStorage from "./IMStorage";
import Forge from 'node-forge'

export default class IMUtils {

    static getUniqueID() {
        let uniqueid = IMUtils.getQueryVariable("deviceid");
        if (uniqueid == null || uniqueid == undefined || uniqueid == '' || uniqueid.length < 3) {
            uniqueid = IMStorage.getItem('DEVICE_ID');
            if (uniqueid == null || uniqueid == undefined || uniqueid == '' || uniqueid.length < 3) {
                let timestamp = Date.parse(new Date());
                let randNum1 = IMUtils.randomTo(0, 1000000000);
                let randNum2 = IMUtils.randomTo(0, 1000000000);
                let randNum3 = IMUtils.randomTo(0, 1000000000);
                uniqueid = IMUtils.md5(timestamp + '' + randNum1 + '' + randNum2 + '' + randNum3);
            }
            IMStorage.setItem('DEVICE_ID', uniqueid);
        }
        return uniqueid;
    }

    static getQueryVariable(variable) {
        if (window.location.search && window.location.search != "") {
            var query = window.location.search.substring(1);

            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) {
                    return pair[1];
                }
            }
        }
        if (window.location.hash && window.location.hash != "") {
            var query = window.location.hash.substring(1);

            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) {
                    return pair[1];
                }
            }
        }
        return null;
    }

    static randomTo(from, to) {
        if (from == to) return from;
        let rd = Math.round(Math.random() * 10);
        return from + (rd % (to - from));
    }

    static md5(str) {
        var md = Forge.md.md5.create();
        md.update(str);
        return md.digest().toHex();
    }

}